import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Typed from "typed.js";
const Container = tw.div`relative 
bg-center
bg-no-repeat
w-full  `;

const TwoCol=styled.div`${tw`flex flex-col items-center lg:flex-row lg:mt-8 mt-2 justify-center pb-5`}`
const Wrapper = tw.div`max-w-screen-xl text-left flex items-center`;
const SubheadingBase = tw.h5`font-bold text-primary-500`;
const Heading = tw.h2` text-2xl  md:mt-0 md:text-2xl xl:text-4.5xl font-black text-black  md:pt-2 pt-4  tracking-wide text-center lg:text-left px-1  `;
const MainColumn = tw.div`flex flex-col  text-center items-center lg:items-center   lg:flex-row  lg:justify-around`;
const ChildColumn=tw.div`lg:flex lg:w-3/6 lg:flex-col`;
const Notification = styled.span`${tw`inline-block my-4  py-1  text-gray-800 text-center lg:text-left  font-medium text-lg`}
`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(
  Column
)`xl:w-15 md:w-1/4 w-3/6 flex-shrink-0 lg:h-72 mt-2  px-8    lg:h-auto relative `;
const MainText = tw.span`bg-primary-600  text-white px-4 inline-block `;

const Description = tw.p`mt-1  px-6 font-semibold  text-xl text-gray-900 text-justify`;
const TypedString = tw.span``;

const ImageHeaderMain = ({imageHeaderData,imgsource,TypingId}) => {
  const [animate, setAnimate] = useState(true);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setAnimate(false);
    }, 1400);
  }, []);
let typedId=TypingId&&TypingId.length>0?TypingId:"element1"
  useEffect(() => {
  var typed = new Typed(`#${typedId}`, {
    strings:[imageHeaderData.description],
     typeSpeed:30
  });
  return () => {
    typed.destroy();
}
 
}, [])

  return (
    <>
      <Container>
        <MainColumn>
          <ImageColumn className={animate && "animate-bounce"} textOnLeft>
            <img src={imgsource} alt="Illustration" className="imageCss" />
          </ImageColumn>
          <ChildColumn>
            <Heading className={animate && "animate-bounce"}>
              {imageHeaderData.key} &nbsp;
              <MainText className="transform -skew-x-12 ">
                {imageHeaderData.title}
              </MainText>
            </Heading>
            <Notification>
              <TypedString
                className="border-blue-800 border-l-4 pl-1 typing"
                id={typedId}
              >
                {imageHeaderData.description}
              </TypedString>
            </Notification>
          </ChildColumn>
        </MainColumn>
        <TwoCol>
          <Wrapper>
            <Description className={animate && "animate-bounce"}>
              {imageHeaderData.detailedDescription}
            </Description>
          </Wrapper>
        </TwoCol>
      </Container>
    </>
  );
};

export default ImageHeaderMain;
